import { LabelsPayload } from "../../components/Labels/types";

const replaceSingleEntry = (labels: LabelsPayload, str?: string): string => {
  const configStr = `Single ${labels.entry.singular}`;
  const replacedStr = str
    ? str.replaceAll("Single Entry", configStr)
    : configStr;

  return replacedStr;
};

export default replaceSingleEntry;
